import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue'
import i18n from './i18n';


import './estiloGlobalPersonalizado.css'
import vuetify from './plugins/vuetify' // El estilo por defecto

//import vuetify from './temaVuetify3.js'; // Ruta al archivo con el tema

import './estiloGlobalPersonalizado.css'; // Importar estilos globales


import { loadFonts } from './plugins/webfontloader'
import store from './store';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import PaginaHome from './components/PaginaHome.vue';
import PaginaLogin from './components/PaginaLogin.vue';
import ComponenteSimulacion from './components/ComponenteSimulacion.vue';
import ComponenteSimulaciones from './components/ComponenteSimulaciones.vue';
//import ComponenteSimulacionesHijas from './components/ComponenteSimulacionesHijas.vue';
//import ComponenteConfiguracion from './components/ComponenteConfiguracion.vue';
import ComponenteConfiguracionGeneral from './components/ComponenteConfiguracionGeneral.vue';
//import TestDiagrama from './components/ComponenteTestDiagrama.vue';

loadFonts()

const routes = [
  { path: '/login', name: 'PaginaLogin', component: PaginaLogin },
  //{ path: '/test-diagrama', name: 'TestDiagrama', component: TestDiagrama },
  { path: '/', name: 'PaginaHome', component: PaginaHome, meta: { requiresAuth: true } ,
    children: [      
      { path: '/', name: 'ComponenteSimulacines', component: ComponenteSimulaciones, meta: { requiresAuth: true } },  
      { path: '/nueva-simulacion', name: 'ComponenteSimulacion', component: ComponenteSimulacion, meta: { requiresAuth: true } },  
      { path: '/configuracion', name: 'ComponenteConfiguracionGeneral', component: ComponenteConfiguracionGeneral, 
        meta: { requiresAuth: true },
        props: {
          curvas: [],
        
        },
      },  

      {
        path: '/resultado-simulacion/:id_padre',
        name: 'ComponenteResultadoSimulacion',
        component: ComponenteSimulacion,
        meta: { requiresAuth: true },
        props: route => ({
          id: route.params.id_padre,
        }),
        children: [
          {
            path: 'hija/:id_hija',
            name: 'ComponenteSimulacionHija',
            components: {
              simulacion_hija: ComponenteSimulacion,
            },
            props: {
              simulacion_hija: route => ({
                id: route.params.id_hija,
                esHijo: "1"
              })
            }
          }
        ]
      },


      { path: '/simulacion/:uuid', name: 'ComponenteSimulacionEnEdicion', component: ComponenteSimulacion, meta: { requiresAuth: true }, props: true },  

      


    ]
  },  
];

const router = createRouter({
  history: createWebHistory(),  
  routes: routes,
});


const app = createApp(App)
app.use(i18n);

fetch('/config.json')
  .then((response) => response.json())
  .then((config) => {
   
    // Proveer la configuración globalmente
    app.provide('config', config);

    
    if (config.nombre_app == "ralph"){
      setFavicon(config.favicon || '/fav-icon-ralph.ico');
    }
    
    if (config.nombre_app == "ophelia"){
      setFavicon(config.favicon || '/fav-icon-ophelia.ico');
    }

    //Bloquear consola si es prod:
if (config.entorno=='prod' && !config.showConsola){
  document.addEventListener('contextmenu', event => event.preventDefault());
  document.addEventListener('keydown', (e) => {
  if (
    e.key === 'F12' ||
    (e.ctrlKey && e.shiftKey && ['I', 'C', 'J'].includes(e.key.toUpperCase())) ||
    (e.ctrlKey && e.key.toUpperCase() === 'U')
  ) {
    e.preventDefault();
    alert('Esta acción está deshabilitada.');
  }
});
}
    

   
  })
  .catch((error) => {
    console.error('Error loading configuration:', error);
  });



/*
router.beforeEach((to, from, next) => {  

  document.title = to.meta.title || 'Ralph';
  
  let faviconUrl = to.meta.favicon || '/fav-icon-ralph.ico';
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = faviconUrl;


  const isAuthenticated = store.state.usuarioAutenticado; 

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {             
    console.log("A Login")
    next('/login')
  } else {
    console.log("A Home")
    next()
  }
});
*/

// Función para cambiar el favicon dinámicamente
function setFavicon(faviconUrl) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = faviconUrl;
  
  // Cambiar el título según el nombre del favicon
  if (faviconUrl.includes('ralph')) {
    document.title = 'Ralph';
  } else {
    document.title = 'Ophelia'; // O cualquier otro título predeterminado
  }
}


// Cambiar favicon dinámicamente en cada ruta
router.beforeEach((to, from, next) => {
  //document.title = to.meta.title || 'Ralph';

  // Usar favicon de la meta de la ruta, o mantener el actual si no está definido
  const faviconUrl = to.meta.favicon || null;
  if (faviconUrl) {
    setFavicon(faviconUrl);
  }
  
  const isAuthenticated = store.state.usuarioAutenticado; 

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {             
    console.log("A Login")
    next('/login')
  } else {
    console.log("A Home")
    next()
  }
});


import VMdPreview from '@kangc/v-md-editor/lib/preview';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import hljs from 'highlight.js';

// Plugin KaTeX vía CDN
import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/cdn';

import 'katex/dist/katex.min.css';

VMdPreview.use(githubTheme, { Hljs: hljs });
VMdPreview.use(createKatexPlugin());


import '@vue-flow/core/dist/style.css' 
import '@vue-flow/core/dist/theme-default.css'

//createApp(App)
app.use(VueSweetalert2);

app.use(router)
app.use(vuetify)
app.use(store)
app.use(VMdPreview);
app.component('VueDatePicker', VueDatePicker);
app.mount('#app')

   



